import { Paragraph as BluBlocksParagraph, Theme } from "@bluframe/blublocks"
import styled from "styled-components"

export const Paragraph = styled(BluBlocksParagraph)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  font-size: 16px;
  line-height: 24px;
`
